import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

export const MapContent: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      gap: 0,
      '& > div': {
        flex: 1,
      },
      '& > div:last-of-type': {
        display: 'none',
        flex: 1,
      },
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        flexDirection: 'row',
        gap: 0,
        '& > div:first-of-type': {
          flex: 'none',
        },
        '& > div:last-of-type': {
          display: 'block',
          flex: 1,
        },
      },
      [`@media (max-width: ${theme.breakPoints.desktop}px)`]: {
        height: '100vh',
        marginTop: 0,
        flexDirection: 'column-reverse',
        gap: 0,
        maxHeight: '100%',
      },
    }}
  >
    {children}
  </Box>
);
